

import React from 'react'

export default function Seperator (props) {
  return <div className="seperator"></div>
}
